export class ContaReceber {
    id: number;
    valor: any;
    juros: any;
    multa: any;
    desconto: any;
    total: any;
    dtVencimento: any;
    dtRecebimento: any;
    dtPagamento: any;
    parcela: string;
    pagamento: any;
    situacao: any;
    observacao: string;
    descricao: string;
    nrDocumento: string;
    codigoBarras: string;
    tipoPagador: string;
    pagador: string;
    pagadorDescricao: string | null;
    clienteId: number | null;
    fornecedorId: number | null;
    colaboradorId?: number | null;
    formaCobranca: string;
    statusCobrancaSicoob: string | null;
    mensagemCobrancaSicoob: string | null;
    nossoNumero: string | null;
    linhaDigitavel: string | null;
    urlBoletoPdf: string | null;
    txidPix: string | null;
    qrCodePix: string | null;
    pixCopiaECola: string | null;
    situacaoDescricao?: string;
    possuiAnexoFatura?: boolean;
    nomeArquivoFatura?: string;
    possuiAnexoBaixa?: boolean;
    nomeArquivoBaixa?: string;
    valorBaixa?: number;
    contaCorrenteId?: number | null;
    contaCorrenteDescricao?: string | null;
    segmentoId?: number | null;
    segmentoNome?: string | null;
    valorAlteradoPor?: string | null;
    valorAlteradoEm?: string | null;
    alteradoPor?: string | null;
    regenerarCobranca?: boolean;
    diasAtraso?: number | null;
    jurosCalculado?: number | null;
    multaCalculada?: number | null;
    totalAtualizado?: number | null;

    constructor(
        id: number, valor: any, juros: any, multa: any, desconto: any, total: any,
        dtVencimento: any, dtRecebimento: any, dtPagamento: any, parcela: string, pagamento: any, situacao: any,
        observacao: string, descricao: string, nrDocumento: string, codigoBarras: string, tipoPagador: string,
        pagador: string, pagadorDescricao: string | null, clienteId: number | null, fornecedorId: number | null,
        formaCobranca: string = 'MANUAL'
    ) {
        this.id = id;
        this.valor = valor;
        this.juros = juros;
        this.multa = multa;
        this.desconto = desconto;
        this.total = total;
        this.dtVencimento = dtVencimento;
        this.dtRecebimento = dtRecebimento;
        this.dtPagamento = dtPagamento;
        this.parcela = parcela;
        this.pagamento = pagamento;
        this.situacao = situacao;
        this.observacao = observacao;
        this.descricao = descricao;
        this.nrDocumento = nrDocumento;
        this.codigoBarras = codigoBarras;
        this.pagador = pagador;
        this.pagadorDescricao = pagadorDescricao;
        this.tipoPagador = tipoPagador;
        this.clienteId = clienteId;
        this.fornecedorId = fornecedorId;
        this.formaCobranca = formaCobranca;
    }
}
